import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Lawyer } from './lawyer';
import { LawyerLevel } from './lawyerLevel';


@JsonObject('LawyerLevelSearchResults')
export class LawyerLevelSearchResults extends SearchResults {
    @JsonProperty('results', [LawyerLevel])
    results: LawyerLevel[] = [];
}
